const DEFAULT_STORAGE_KEY = 'cp_sync_queue';
export class SyncEngine {
    constructor(storage, processor, config) {
        this.queue = [];
        this.isProcessing = false;
        this.storage = storage;
        this.processor = processor;
        this.storageKey = config?.storageKey ?? DEFAULT_STORAGE_KEY;
        this.maxQueueSize = config?.maxQueueSize ?? 500;
    }
    async init() {
        await this.load();
    }
    getQueue() {
        return [...this.queue];
    }
    async enqueue(task) {
        if (this.queue.length >= this.maxQueueSize) {
            // Drop the oldest task to keep moving forward
            this.queue.shift();
        }
        this.queue.push(task);
        await this.persist();
    }
    async processAll() {
        if (this.isProcessing)
            return;
        this.isProcessing = true;
        try {
            while (this.queue.length > 0) {
                const task = this.queue[0];
                if (!task)
                    break;
                await this.processor(task);
                this.queue.shift();
                await this.persist();
            }
        }
        finally {
            this.isProcessing = false;
        }
    }
    async load() {
        const raw = await this.storage.getItem(this.storageKey);
        if (!raw)
            return;
        try {
            const parsed = JSON.parse(raw);
            if (Array.isArray(parsed)) {
                this.queue = parsed;
            }
        }
        catch {
            // ignore malformed
            this.queue = [];
        }
    }
    async persist() {
        await this.storage.setItem(this.storageKey, JSON.stringify(this.queue));
    }
}
